module.exports = "https://staticsandbox.coteibem.com.br/assets/modal-close.c6d29a7a0419fb14b5f0765744793392.svg";